<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-5 col-md-12 mb-4">
                      <h2>Bid Wanteds</h2>
                      <div class="ims-tab ml-0">
                        <router-link to="/autobidder/bids" class="inv-btn" >
                          <button class="btn" v-bind:class="{ 'active': $route.name =='autoBidList' }" >
                            Active Bid Wanteds
                          </button>
                        </router-link>
                        <router-link to="/autobidder/bids/mybids">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='myBidList' }" >
                            My Bids
                          </button>
                        </router-link>
                      </div>
                    </div>
                </div>
                <!-- Card stats -->
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div> 
        
</template>
<script>

export default {
  name: "bids",
  components : {

  },
  data() {
    return {

    };
  },
  methods: {

  },
  mounted() {


  }
};
</script>